"use strict";

export default {
	latLngToPoint,
	coordinateToLatLng,
	pointToLatLng,
	positionToLatLng,
	areEqualPositions,
	boundsLiteralToBounds
};

export {latLngToPoint as latLngToPoint};
export {coordinateToLatLng as coordinateToLatLng};
export {pointToLatLng as pointToLatLng};
export {positionToLatLng as positionToLatLng};
export {areEqualPositions as areEqualPositions};
export {boundsLiteralToBounds as boundsLiteralToBounds};

function latLngToPoint(latLng) {
	return {
		type: "Point",
		coordinates: [latLng.lng(), latLng.lat()]
	};
}

function coordinateToLatLng(coord){
	return new google.maps.LatLng(coord[1], coord[0]);
}

function pointToLatLng(point) {
	if (!point || !point.coordinates)
		return null;
	
	return coordinateToLatLng(point.coordinates);
}

function positionToLatLng(position) {
	if (!position || !position.point)
		return null;
	
	return pointToLatLng(position.point);
}

function areEqualPositions(p1, p2) {
	if (p1.lat() == p2.lat() && p1.lng() == p2.lng())
		return true;
	else return false;
}

function boundsLiteralToBounds(literal) {
	const sw = new google.maps.LatLng(literal.south, literal.west);
	const ne = new google.maps.LatLng(literal.north, literal.east);
	return new google.maps.LatLngBounds(sw, ne);
}


// WEBPACK FOOTER //
// ./src/utils/geo.js